// Load this in the head.
// DEBT(leo): s5cr6p Export a `run` function instead of self running code

import { win } from "./lib/pd-window.js";
import {
  loadSegment,
  verifyCloudflareWorkersMetaTags,
} from "./segment/initialization.js";
import { getSegment } from './segment/helpers';
import { loadScript, noAttrs } from "./lib/load-script.js";
import { loadPDTracking } from "./pd-tracking-code";
import { initDemandbaseEmailUpdate } from "./lib/demandbaseEmailFieldUpdate.js";
import { initLangSelector } from "./lang-selector.js";
import { setupSiteLanguage } from "./lib/lang.js";

// /////////////////////////////////////////////////////////////////////////////
// Bugsnag
(function setupBugsnag() {
  const hostname = window.location.hostname;
  let releaseStage = "development";
  if (/www\.pagerduty\.com/.test(hostname)) releaseStage = "production";
  else if (/staging/.test(hostname)) releaseStage = "staging";

  function onload() {
    win.Bugsnag.start({
      apiKey: "b6499f73a94766f8735d4634b5b3085f",
      appType: "client",
      appVersion: win.pd.appVersion || "Not set",
      releaseStage: releaseStage,
      // metadata: {
      //   adBlocker: 'unknown'
      // }
    });
    verifyCloudflareWorkersMetaTags();
  }
  loadScript("//d2wy8f7a9ursnm.cloudfront.net/v8/bugsnag.min.js", noAttrs, {
    onload,
  });
})();

function setUpDemandBase() {
  (function (d, b, a, s, e) {
    var t = b.createElement(a),
      fs = b.getElementsByTagName(a)[0];
    t.async = 1;
    t.id = e;
    t.src = s;
    fs.parentNode.insertBefore(t, fs);
  })(
    window,
    document,
    "script",
    "//tag.demandbase.com/oJB4Bebp.min.js",
    "demandbase_js_lib"
  );
}

function setUpMunchkin() {
  (function () {
    var didInit = false;
    function initMunchkin() {
      if (didInit === false) {
        didInit = true;
        Munchkin.init("093-VPJ-807");
      }
    }
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "//munchkin.marketo.net/munchkin.js";
    s.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        initMunchkin();
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName("head")[0].appendChild(s);
  })();
}

// Load Drift Chat bot
function setupDrift() {
  var t = (window.driftt = window.drift = window.driftt || []);
  if (!t.init) {
    if (t.invoked)
      return void (
        window.console &&
        console.error &&
        console.error("Drift snippet included twice.")
      );
    (t.invoked = !0),
      (t.methods = [
        "identify",
        "config",
        "track",
        "reset",
        "debug",
        "show",
        "ping",
        "page",
        "hide",
        "off",
        "on",
      ]),
      (t.factory = function (e) {
        return function () {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }),
      t.methods.forEach(function (e) {
        t[e] = t.factory(e);
      }),
      (t.load = function (t) {
        var e = 3e5,
          n = Math.ceil(new Date() / e) * e,
          o = document.createElement("script");
        (o.type = "text/javascript"),
          (o.async = !0),
          (o.crossorigin = "anonymous"),
          (o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js");
        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(o, i);
      });
  }

  drift.SNIPPET_VERSION = "0.3.1";
  drift.load("gu5t2gn38mfn");

  // Drift events
  var driftEvents = [
    {driftEventType: 'conversation', driftEventName: 'conversation:playbookClicked', driftEventDescription: 'playbook clicked', segmentEventName: 'drift_playbook_clicked'},
    {driftEventType: 'conversation', driftEventName: 'conversation:buttonClicked', driftEventDescription: 'button clicked', segmentEventName: 'drift_button_clicked'},
    {driftEventType: 'conversation', driftEventName: 'startConversation', driftEventDescription: 'user started a new chat', segmentEventName: 'drift_started_chat'},
    {driftEventType: 'conversation', driftEventName: 'emailCapture', driftEventDescription: 'user submitted email address', segmentEventName: 'drift_email_captured'},
    {driftEventType: 'conversation', driftEventName: 'scheduling:requestMeeting', driftEventDescription: 'schedule meeting card pushed to a conversation', segmentEventName: 'drift_meeting_requested'},
    {driftEventType: 'conversation', driftEventName: 'scheduling:meetingBooked', driftEventDescription: 'user booked a meeting', segmentEventName: 'drift_meeting_booked'}
  ]

  // Set Drift Chat zIndex to show behind OneTrust cookie banner
  drift.on('ready', function(api, payload) {
    const driftWidget = document.getElementById('drift-frame-controller');
    driftWidget.style.zIndex = 3;

    driftEvents.forEach(function (driftEvent) {
      drift.on(driftEvent.driftEventName, function (data) {
        driftEvent.event = 'drift';
        driftEvent.driftEventData = data;

        // push Drift info to Segment
        getSegment("track")(driftEvent.segmentEventName, data);

      })
    });
  });
}

/** 
 * @typedef {Object} Bucket
 * @prop {boolean} wasAdded
 * @prop {'C0001'|'C0002'|'C0003'|'C0004'} groupClass
 * @prop {()=>void} load
 */

/** 
 * @typedef {Object} Buckets
 * @prop {Bucket} necessary
 * @prop {Bucket} functional
 * @prop {Bucket} performance
 * @prop {Bucket} targeting
 */

/** @type {Buckets} */
const buckets = {
  necessary: {
    wasAdded: false,
    groupClass: "C0001",
    load() {
      if (this.wasAdded) return;
      this.wasAdded = true;
      setTimeout(setupDrift, 1000);
    },
  },
  performance: {
    wasAdded: false,
    groupClass: "C0002",
    load() {
      if (this.wasAdded) return;
      this.wasAdded = true;
      loadPDTracking();
      // NOTE(leo): As of Jun 8 2022, the GTM performance bucket doesn't have
      // any scripts to load. Disabling it to reduce network requests and loaded
      // scripts.
      // If needed in the future, uncomment it
      // setupGoogleTagManager('GTM-P3R47CT');
    },
  },
  functional: {
    wasAdded: false,
    groupClass: "C0003",
    load() {
      if (this.wasAdded) return;
      this.wasAdded = true;
      // It is assumed that segment's anaytics object has already been
      // initialized globally allowing early track calls to be recorded before
      // they are sent to segment once the library loads.
      loadSegment();
    },
  },
  targeting: {
    wasAdded: false,
    groupClass: "C0004",
    load() {
      if (this.wasAdded) return;
      this.wasAdded = true;
      setUpDemandBase();
      setUpMunchkin();
    },
  },
};

/**
 * OneTrust OptanonWrapper callback
 * OptanonWrapper() will get called by Onetrust once it's loaded, instantiated
 * and OptanonActiveGroups have been set.
 * https://my.onetrust.com/s/article/UUID-29158b4e-22f6-0067-aa36-94f3b8cf3561
 */
win.OptanonWrapper = () => {
  // Convert OptanonActiveGroups to an array of strings.
  // Since OptanonActiveGroups can start and end with `,` and could have spaces
  // between the items e.g.: ',C0002, C0004,' it need to be filtered.
  /** @type {string[]} */
  const activeGroups = win.OnetrustActiveGroups.split(",").filter(
    (it) => 0 < it.trim().length
  );
  for (let i = 0, n = activeGroups.length; i < n; i++) {
    const groupClass = activeGroups[i];
    /** @type {keyof buckets}*/
    let bucketKey;
    for (bucketKey in buckets) {
      const bucket = buckets[bucketKey];
      if (bucket.groupClass === groupClass) bucket.load();
    }
  }
};

document.addEventListener("DOMContentLoaded", function onDomReady() {
  initDemandbaseEmailUpdate(); // Nothing is done if there are no forms
  initLangSelector();
  document.removeEventListener("DOMContentLoaded", onDomReady);
});

// Add language to the window object
setupSiteLanguage();